module.exports = __webpack_public_path__ + "img/community-norm_en.55e1b31c.png";